
import * as React from 'react';
import { createSlotFill, Lifecycle } from '@workbench-stack/components';
import { EDITOR_SLOT_PROVIDER } from '../constants';
import { Registry } from '@vscode-alt/monaco-editor/esm/vs/platform/registry/common/platform';
import { IEditorRegistry, IEditorInput, CacheTypenames, LifecyclePhase } from '@workbench-stack/core';
import { ClientExtensions } from '../constants';



export type IEditorComponentProps = { input: IEditorInput, visibleEditorId: string };


export type IEditorSlotProps = { input: IEditorInput };

export const { Fill: EditorContributionFill, Slot: EditorSlot } = createSlotFill<IEditorComponentProps>(EDITOR_SLOT_PROVIDER);

export const Editor: React.FC<IEditorSlotProps> = (props) => {
    const registry = Registry.as<IEditorRegistry>(ClientExtensions.Editors);
    const typename = props.input ? props.input.__typename : CacheTypenames.ResourceEditorInput;
    const typeId = props.input ? props.input.typeId : undefined;
    const preferredEditorId = props.input ? props.input.preferredEditorId : undefined;
    const editorDescriptor = registry.getEditor({ __typename: typename, typeId, preferredEditorId });

    return React.useMemo(() => {
        return (
            editorDescriptor ? <Lifecycle renderWhenPhase={LifecyclePhase.Restored}><EditorSlot fillProps={{ ...props, visibleEditorId: editorDescriptor.id }} /> </Lifecycle> : null
        );
    }, [props.input.resource, props.input.label]);
};




